import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIndustry = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.3442 16.5993H3.65811C3.57056 16.5953 3.48467 16.574 3.40543 16.5366C3.32619 16.4991 3.25519 16.4463 3.19657 16.3812C3.13794 16.316 3.09286 16.2399 3.06394 16.1572C3.03503 16.0744 3.02286 15.9868 3.02815 15.8993L3.00015 4.68876C2.99639 4.51027 3.06353 4.33756 3.18685 4.20846C3.31017 4.07936 3.47963 4.00441 3.65811 4H6.71973C6.89796 4.00477 7.06707 4.07989 7.19009 4.20894C7.31311 4.338 7.38005 4.5105 7.37629 4.68876V10.3304L11.1799 7.77978C11.2832 7.7099 11.4051 7.67238 11.5298 7.67198C11.7085 7.67675 11.8779 7.75202 12.0012 7.88134C12.1245 8.01065 12.1916 8.18351 12.1878 8.36214V10.322L16.0194 7.77978C16.121 7.71058 16.2408 7.67307 16.3638 7.67198C16.5403 7.67997 16.7064 7.75776 16.8256 7.88824C16.9448 8.01872 17.0073 8.1912 16.9993 8.36774V15.8993C17.0046 16.0788 16.9387 16.2532 16.816 16.3843C16.6932 16.5154 16.5236 16.5927 16.3442 16.5993ZM12.437 12.3995V13.6496H13.6283V12.3995H12.437ZM9.80375 12.3995V13.6496H10.9951V12.3995H9.80375ZM7.1579 12.3995V13.6496H8.34783V12.3995H7.1579Z",
		fill: "#0D2976"
	})
});
export default SvgIndustry;
